import { render, staticRenderFns } from "./Termo.vue?vue&type=template&id=a62e37e4&scoped=true&"
import script from "./Termo.vue?vue&type=script&lang=js&"
export * from "./Termo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62e37e4",
  null
  
)

export default component.exports